// ═══════════════════════════════════════════════════════════════
//  CZARD Contact — czard-contact.js  (Final)
//  - Fixes tab switching (was broken by submit intercept)
//  - Routes submissions to Google Apps Script → Freshdesk
//  - Success: "Request received successfully. Reference: CZARD-1048"
//  - Failure: error shown, form re-enabled for retry
//  - Success message: centered, no border, clean
// ═══════════════════════════════════════════════════════════════

(function () {
  'use strict';

  var APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxj5pErNAM0zrpidUIU9tMnQJ55FynzyDUDXyFwhJYJMO6okPgLPJe31kYT7JNCfziI/exec';

  // ─────────────────────────────────────────
  //  Boot
  // ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
    initTabs();
    initForms();
    injectStyles();
  }

  // ═══════════════════════════════════════════════════════════════
  //  TAB SWITCHING — full re-implementation
  //  The original czard-contact.js handled tabs. Replacing that
  //  file means we must re-implement tab switching here.
  // ═══════════════════════════════════════════════════════════════

  function initTabs() {
    var sections = document.querySelectorAll('[data-czard-contact]');
    sections.forEach(function (section) {
      var tabs   = section.querySelectorAll('.czc__tab');
      var panels = section.querySelectorAll('.czc__panel');

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(tabs, panels, index);
        });

        // Keyboard: arrow keys to move between tabs
        tab.addEventListener('keydown', function (e) {
          var current = Array.prototype.indexOf.call(tabs, tab);
          var next = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            next = (current + 1) % tabs.length;
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            next = (current - 1 + tabs.length) % tabs.length;
          } else if (e.key === 'Home') {
            next = 0;
          } else if (e.key === 'End') {
            next = tabs.length - 1;
          }
          if (next !== -1) {
            e.preventDefault();
            activateTab(tabs, panels, next);
            tabs[next].focus();
          }
        });
      });
    });
  }

  function activateTab(tabs, panels, index) {
    tabs.forEach(function (t, i) {
      var isActive = (i === index);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    panels.forEach(function (p, i) {
      if (i === index) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════
  //  FORM INTERCEPTION
  // ═══════════════════════════════════════════════════════════════

  function initForms() {
    var sections = document.querySelectorAll('[data-czard-contact]');
    sections.forEach(function (section) {
      var forms = section.querySelectorAll('.czc__form');
      forms.forEach(function (form) {
        interceptForm(form);
      });
    });
  }

  function interceptForm(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      // Detect tab type
      var panel    = form.closest('.czc__panel');
      var panelId  = panel ? panel.id : '';
      var isRepairs = panelId.indexOf('repairs') !== -1;

      // Collect + validate
      var data = collectData(form, isRepairs);
      var err  = validate(data, isRepairs);
      if (err) { showError(form, err); return; }

      // Lock button
      var btn = form.querySelector('[type="submit"]');
      lockBtn(btn);
      clearMsg(form);

      // Send
      sendData(data)
        .then(function (result) {
          if (result.success) {
            showSuccess(form, result.ticketId, isRepairs);
            form.reset();
          } else {
            showError(form, result.error || 'Something went wrong. Please try again.');
            unlockBtn(btn);
          }
        })
        .catch(function () {
          showError(form, 'Could not reach our server. Please try again or email care@czard.com');
          unlockBtn(btn);
        });
    });
  }

  // ─────────────────────────────────────────
  //  Send to Apps Script — tries cors first,
  //  falls back to no-cors if blocked
  // ─────────────────────────────────────────
  function sendData(data) {
    return fetch(APPS_SCRIPT_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body:    JSON.stringify(data),
      redirect: 'follow'
    })
    .then(function (res) { return res.text(); })
    .then(function (text) {
      try   { return JSON.parse(text); }
      catch  { return { success: true, ticketId: null }; }
    })
    .catch(function () {
      // Network blocked — fire no-cors as fallback
      return fetch(APPS_SCRIPT_URL, {
        method:  'POST',
        mode:    'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body:    JSON.stringify(data)
      }).then(function () {
        return { success: true, ticketId: null };
      });
    });
  }

  // ─────────────────────────────────────────
  //  Collect field values
  // ─────────────────────────────────────────
  function collectData(form, isRepairs) {
    var d = {
      formType: isRepairs ? 'repairs' : 'question',
      name:     v(form, '[name="contact[Name]"]'),
      email:    v(form, '[name="contact[email]"]'),
      phone:    v(form, '[name="contact[Phone]"]'),
      message:  v(form, '[name="contact[body]"]')
    };
    var consentEl = form.querySelector('[name="contact[Consent]"]');
    d.consent = consentEl ? (consentEl.checked ? 'Given' : 'Not given') : 'Not required';
    if (isRepairs) {
      d.orderNumber = v(form, '[name="contact[Order number]"]');
      d.watchModel  = v(form, '[name="contact[Watch model]"]');
    }
    return d;
  }

  function v(form, sel) {
    var el = form.querySelector(sel);
    return el ? (el.value || '').trim() : '';
  }

  // ─────────────────────────────────────────
  //  Validation
  // ─────────────────────────────────────────
  function validate(d, isRepairs) {
    if (!d.name)    return 'Please enter your full name.';
    if (!d.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email))
                    return 'Please enter a valid email address.';
    if (!d.message) return 'Please enter your message.';
    if (isRepairs && !d.orderNumber) return 'Please enter your order number.';
    if (isRepairs && !d.watchModel)  return 'Please enter your watch model.';
    return null;
  }

  // ─────────────────────────────────────────
  //  Success — clean centered message
  // ─────────────────────────────────────────
  function showSuccess(form, ticketId, isRepairs) {
    hideFields(form);

    var ref = ticketId ? 'CZARD-' + ticketId : 'CZARD-' + localRef();

    var box = document.createElement('div');
    box.className = 'czc-fd-success';

    box.innerHTML =
      '<div class="czc-fd-success__icon" aria-hidden="true">' +
        '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
          '<polyline points="20 6 9 17 4 12"/>' +
        '</svg>' +
      '</div>' +
      '<p class="czc-fd-success__title">Request received successfully.</p>' +
      '<p class="czc-fd-success__ref">Reference: <strong>' + ref + '</strong></p>' +
      '<p class="czc-fd-success__note">' +
        'Our team will be in touch shortly' +
        (isRepairs ? ' regarding your repair request.' : '.') +
      '</p>' +
      '<button type="button" class="czc__button czc-fd-success__btn" data-czard-new>' +
        'Send another message' +
      '</button>';

    form.appendChild(box);

    box.querySelector('[data-czard-new]').addEventListener('click', function () {
      box.remove();
      showFields(form);
    });
  }

  // ─────────────────────────────────────────
  //  Error message
  // ─────────────────────────────────────────
  function showError(form, message) {
    clearMsg(form);
    var p = document.createElement('p');
    p.className = 'czc__note czc__note--error czc-fd-msg';
    p.setAttribute('role', 'alert');
    p.textContent = message;
    form.insertBefore(p, form.firstChild);
    p.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearMsg(form) {
    form.querySelectorAll('.czc-fd-msg').forEach(function (el) { el.remove(); });
  }

  // ─────────────────────────────────────────
  //  Show / hide form fields
  // ─────────────────────────────────────────
  function hideFields(form) {
    form.querySelectorAll(
      '.czc__field, .czc__row, .czc__consent, [type="submit"], [type="hidden"]'
    ).forEach(function (el) {
      el.setAttribute('data-czard-hidden', '');
      el.style.display = 'none';
    });
  }

  function showFields(form) {
    form.querySelectorAll('[data-czard-hidden]').forEach(function (el) {
      el.removeAttribute('data-czard-hidden');
      el.style.display = '';
    });
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = false; }
  }

  // ─────────────────────────────────────────
  //  Button helpers
  // ─────────────────────────────────────────
  function lockBtn(btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('data-orig', btn.textContent);
    btn.textContent = 'Sending...';
  }

  function unlockBtn(btn) {
    if (!btn) return;
    btn.disabled = false;
    btn.textContent = btn.getAttribute('data-orig') || 'Send my message';
  }

  // ─────────────────────────────────────────
  //  Local reference fallback
  // ─────────────────────────────────────────
  function localRef() {
    return Date.now().toString().slice(-6);
  }

  // ═══════════════════════════════════════════════════════════════
  //  SUCCESS MESSAGE STYLES — injected so no CSS file change needed
  // ═══════════════════════════════════════════════════════════════

  function injectStyles() {
    if (document.getElementById('czc-fd-styles')) return;
    var style = document.createElement('style');
    style.id  = 'czc-fd-styles';
    style.textContent = [

      /* Success box — centered, no border, clean */
      '.czc-fd-success {',
      '  display: flex;',
      '  flex-direction: column;',
      '  align-items: center;',
      '  justify-content: center;',
      '  text-align: center;',
      '  padding: 3rem 1rem;',
      '  background: transparent;',
      '  border: none;',
      '  outline: none;',
      '}',

      /* Checkmark circle */
      '.czc-fd-success__icon {',
      '  width: 56px;',
      '  height: 56px;',
      '  border-radius: 50%;',
      '  border: 1.5px solid currentColor;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  margin-bottom: 1.25rem;',
      '  opacity: 0.7;',
      '}',

      /* Main line */
      '.czc-fd-success__title {',
      '  font-size: 1rem;',
      '  font-weight: 500;',
      '  letter-spacing: 0.02em;',
      '  margin: 0 0 0.5rem;',
      '  color: inherit;',
      '}',

      /* Reference number */
      '.czc-fd-success__ref {',
      '  font-size: 0.85rem;',
      '  letter-spacing: 0.08em;',
      '  margin: 0 0 1rem;',
      '  color: inherit;',
      '  opacity: 0.8;',
      '}',

      '.czc-fd-success__ref strong {',
      '  font-weight: 600;',
      '  letter-spacing: 0.1em;',
      '}',

      /* Sub note */
      '.czc-fd-success__note {',
      '  font-size: 0.8rem;',
      '  margin: 0 0 1.75rem;',
      '  color: inherit;',
      '  opacity: 0.6;',
      '  line-height: 1.6;',
      '}',

      /* Send another button — matches czc__button style */
      '.czc-fd-success__btn {',
      '  cursor: pointer;',
      '}',

      /* Override any default note styles that add a border */
      '.czc__note.czc__note--ok.czc__fd-success,',
      '.czc-fd-success {',
      '  border: none !important;',
      '  background: transparent !important;',
      '}',

    ].join('\n');
    document.head.appendChild(style);
  }

})();